import { FIXTURE_STATUS } from '@/constants/fixture';

export const useFixtureStatusShort = (status) => {
    switch (status) {
        case FIXTURE_STATUS.FIRST_HALF:
            return '1T';
        case FIXTURE_STATUS.HALF_TIME:
            return 'ET';
        case FIXTURE_STATUS.SECOND_HALF:
            return '2T';
        case FIXTURE_STATUS.EXTRA_TIME:
            return 'TE';
        case FIXTURE_STATUS.BREAK_TIME:
            return 'BT';
        case FIXTURE_STATUS.WALKOVER:
            return 'WO';
        case FIXTURE_STATUS.PENALTIES:
            return 'P';
        case FIXTURE_STATUS.LIVE:
            return 'L';
        case FIXTURE_STATUS.TO_BE_DEFINED:
        case FIXTURE_STATUS.NOT_STARTED:
            return 'PE';
        case FIXTURE_STATUS.MATCH_SUSPENDED:
        case FIXTURE_STATUS.MATCH_INTERRUPTED:
        case FIXTURE_STATUS.MATCH_CANCELED:
        case FIXTURE_STATUS.MATCH_POSTPONED:
            return 'PP';
        case FIXTURE_STATUS.MATCH_FINISHED:
        case FIXTURE_STATUS.MATCH_FINISHED_AFTER_EXTRA_TIME:
        case FIXTURE_STATUS.MATCH_FINISHED_AFTER_PENALTIES:
        case FIXTURE_STATUS.TECHNICAL_LOSS:
        case FIXTURE_STATUS.MATCH_ABANDONED:
            return 'Fin';
        default:
            return 'FIN';
    }
};

export const useFixtureStatusLong = (status) => {
    switch (status) {
        case FIXTURE_STATUS.FIRST_HALF:
            return 'Primera mitad';
        case FIXTURE_STATUS.HALF_TIME:
            return 'Entretiempo';
        case FIXTURE_STATUS.SECOND_HALF:
            return 'Segunda mitad';
        case FIXTURE_STATUS.EXTRA_TIME:
            return 'Tiempo extra';
        case FIXTURE_STATUS.BREAK_TIME:
            return 'Entretiempo (tiempo extra)';
        case FIXTURE_STATUS.WALKOVER:
            return 'Walkover';
        case FIXTURE_STATUS.PENALTIES:
            return 'Penaltis';
        case FIXTURE_STATUS.LIVE:
            return 'En directo';
        case FIXTURE_STATUS.TO_BE_DEFINED:
        case FIXTURE_STATUS.NOT_STARTED:
            return 'No comenzado';
        case FIXTURE_STATUS.MATCH_SUSPENDED:
        case FIXTURE_STATUS.MATCH_INTERRUPTED:
        case FIXTURE_STATUS.MATCH_CANCELED:
        case FIXTURE_STATUS.MATCH_POSTPONED:
            return 'Pospuesto';
        case FIXTURE_STATUS.MATCH_FINISHED:
        case FIXTURE_STATUS.MATCH_FINISHED_AFTER_EXTRA_TIME:
        case FIXTURE_STATUS.MATCH_FINISHED_AFTER_PENALTIES:
        case FIXTURE_STATUS.TECHNICAL_LOSS:
        case FIXTURE_STATUS.MATCH_ABANDONED:
        default:
            return 'Finalizado';
    }
};
